import { horizontalListSortingStrategy, SortableContext } from '@dnd-kit/sortable'
import { Box, Card, CardContent, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import {
  RailcarPlanningDraggableEnum,
  RailcarPlanningViewStore,
} from '../../Stores/RailcarPlanningViewStore'
import { RailcarPlanningDroppableRailcar } from '../Organisms/RailcarPlanningDroppableRailcar'
import { RailcarPlanningRailcarProps } from './RailcarPlanningRailcar'

type Props = RailcarPlanningRailtrackProps & {
  railcarPlanningViewStore: RailcarPlanningViewStore
  filter?: string | null
}

export type RailcarPlanningRailtrackProps = {
  id: string
  trackName: string
  railcars: RailcarPlanningRailcarProps[]
}

export const RailcarPlanningRailtrack: FC<Props> = observer(props => {
  const { trackName, railcars } = props
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  return (
    <Card
      sx={{
        position: 'relative',
        overflow: 'visible',
        backgroundColor: theme.palette.grey[200],
        border: `1px solid ${theme.palette.grey[300]}`,
        height: '280px',
        width: 'max-content',
        minWidth: '-webkit-fill-available',
      }}
    >
      <CardContent>
        <Stack>
          <Typography
            variant='subtitle1'
            sx={{
              position: 'sticky',
              left: `calc(${theme.customSpacing.m} - 2px)`,
              mb: theme.customSpacing.m,
              width: 'fit-content',
              zIndex: 10,
            }}
          >
            {trackName}
          </Typography>
          <SortableContext
            items={railcars.map(railcar => `${RailcarPlanningDraggableEnum.RAILCAR}:${railcar.id}`)}
            strategy={horizontalListSortingStrategy}
          >
            <Stack display={'flex'} direction='row' spacing={theme.customSpacing.l}>
              {railcars?.map(railcar => (
                <RailcarPlanningDroppableRailcar
                  railcarPlanningViewStore={props.railcarPlanningViewStore}
                  key={railcar.id}
                  railcar={railcar}
                  filter={props.filter}
                />
              ))}
              {railcars.length === 0 && (
                <Box
                  sx={{
                    display: 'flex',
                    placeContent: 'center',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    height: 160,
                    width: 'fit-content',
                    position: 'sticky',
                    left: '50%',
                  }}
                >
                  <Typography variant='body2' color='textSecondary'>
                    {t('noRailcarsOnThisTrack', 'No railcars on this track')}
                  </Typography>
                </Box>
              )}
            </Stack>
          </SortableContext>
        </Stack>
      </CardContent>
    </Card>
  )
})
